import { duration } from "moment";
import { apiSlice } from "./apiSlice";

export const insuranceSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllInsurance: builder.query({
            query: (params) => ({
                url: `Insurance`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["InsuranceTracker"],
        }),


        // getSingleIrrDetails: builder.query({
        //     query: ({ IncidentTracker, params }) => ({
        //         url: `IncidentTracker/${IncidentTracker}`,
        //         params,
        //     }),
        //     keepUnusedDataFor: 0,
        //     refetchOnMountOrArgChange: true,
        // }),

        createInsurance: builder.mutation({
            query: ({ body }) => ({
                url: `Insurance`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["InsuranceTracker"],
        }),

        updateInsurance: builder.mutation({
            query: ({ body }) => ({
                url: `Insurance`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["InsuranceTracker"],
        }),


        // getAllIrrCount: builder.query({
        //     query: (params) => ({
        //         url: `IncidentTracker/summary`,
        //         params,
        //     }),
        //     invalidatesTags: ["Incident"],
        // }),
         getExportInsurance: builder.query({
            query: (params) => ({
                url: `Insurance`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),



    }),
});

export const {
    useCreateInsuranceMutation, useLazyGetAllInsuranceQuery, useGetAllInsuranceQuery, useUpdateInsuranceMutation,
    useLazyGetExportInsuranceQuery
} = insuranceSlice;